import type { AddressSchema, CompanyDataSchema } from "../api-types/company_data_schemas";

export const prepAddress = (data: CompanyDataSchema, name: string): AddressSchema | null => {
  return Object.values(data[name]).every((x) => x == null || x === "")
    ? null
    : { ...data[name], ...{ country: data.country } };
};
